import { BillingOrShippingAddressDto } from '../../..';

export class UpdateTicketOrderAddressDto {
  billingAddress: BillingOrShippingAddressDto;
  shippingAddress: BillingOrShippingAddressDto;
}
